import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, HostListener, Input, AfterViewInit, Inject, ViewEncapsulation } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';

import { DashboardFilter } from '../../../models/DashboardFilter';

import { BroadcastService } from './../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../services/infrastructure/config.service';
import { ProductLineDeliveryInstructionSliderModelService } from '../product-line-delivery-instructions/product-line-delivery-instructions-slider-model.service';

import { LocalStorageService } from './../../../services/infrastructure/local-storage.service';
import { LoaderService } from './../../../services/infrastructure/loader.service';
import { ConfirmDialogComponent } from '../../../common/components/confirm-dialog/confirm-dialog.component';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { SeedFulfillmentService } from '../../../services/seed/seed-fulfillment.service';
import { DeliveryInstructionService } from '../../../services/seed/delivery-Instruction.service';
import { MasterConstants } from '../../constants/master-constants';
import { LolLoggerService } from './../../../common/shared/lol-logger.service';
import { CommonService } from './../../../services/common/common.service';

@Component({
  selector: 'app-product-line-delivery-instructions',
  templateUrl: './product-line-delivery-instructions.component.html',
  styleUrls: ['./product-line-delivery-instructions.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class ProductLineDeliveryInstructionsComponent implements OnInit, AfterViewInit {
  accountNumber: number;
  column: any;
  contactTypeList: any = [];
  cropYear: any;
  currentErrorRow = 1;
  dashboardFilter: DashboardFilter;
  dataChangeSubscription: any;
  deliveryInstructionDS: MatTableDataSource<DeliveryInstructionsData>;
  deliveryInstructionList: any = [];
  deliveryInstruction: MatTableDataSource<any>;
  displayedColumns: string[] = ['edit', 'select', 'productLine', 'contactType', 'firstName', 'lastName', 'phone', 'emailAddress', 'deliveryInstructions', 'action', 'sarEmail'];
  emailPattern: any = MasterConstants.EMAIL_PATTERN;
  errorMsgs = new Array();
  errorsList: Array<string> = [];
  error = false;
  hasChangeAdded = false;
  headerCompany: any;
  headerYear: any;
  index = 0;
  isDeliveryInstrcutionAccess = false;
  isEditMode = false;
  isRadioButtonDisabled = false;
  isSaveDisabled = true;
  isSelectDIDisabled = true;
  nextErrorId = 0;
  productAllDataSource = new MatTableDataSource();
  productLineId: Array<string>;
  productLineList: any = [];
  productLineMasterList: any = [];
  selectedDI: any;
  showErrorBlock = false;
  submitButtonClicked = false;
  isValid: boolean;
  constructor(public http: HttpClient,
    @Inject('BASE_URL') public baseUrl: string,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private deliveryInstructionService: DeliveryInstructionService,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    private matDialog: MatDialog,
    private productLineDeliveryInstructionSliderModelService: ProductLineDeliveryInstructionSliderModelService,
    private router: Router,
    private seedFulfillmentService: SeedFulfillmentService,
    private toastrService: ToastrService,
    private commonService: CommonService
  ) {
    this.dashboardFilter = new DashboardFilter();
    this.dataChangeSubscription = this.broadcastService.on<any>(this.configService.DATA_CHANGE_ADDED).subscribe((data) => {
      if (data.hasChangeAdded != undefined) {
        this.hasChangeAdded = data.hasChangeAdded;
      }
    });
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
  }

  ngOnInit() {
    this.productLineDeliveryInstructionSliderModelService.deliveryInstructionsMasterData.subscribe(deliveryInstructionsMasterList => {
      this.deliveryInstructionList = deliveryInstructionsMasterList;
    });
    this.productLineDeliveryInstructionSliderModelService.deliveryInstructionsProductLineData.subscribe(productLineMasterList => {
      this.productLineList = productLineMasterList;
    });

    this.accountNumber = this.productLineDeliveryInstructionSliderModelService.accountNumber;
    this.productLineId = this.productLineDeliveryInstructionSliderModelService.productLineIds;
    this.contactTypeList = ContactType;
    this.getDeliveryInstructions(this.accountNumber, this.productLineId);

    this.isDeliveryInstrcutionAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.DELIVERY_INSTRUCTIONS, MasterConstants.USER_ACCESS.EDIT_FULL);
    if (!this.isDeliveryInstrcutionAccess) {
      this.isDeliveryInstrcutionAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.FULFILLMENT_SHIPPING_AVAILABILITY_REPORT, MasterConstants.USER_ACCESS.EDIT_FULL);
    }
  }

  // ngAfterViewInit
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setSeedEditPageHeight();
  }
  // Tab changed
  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
  };

  // Get delivery instructions by ship to and deliver account
  getDeliveryInstructions(accountNumber, productLineId) {
    if (accountNumber != null && accountNumber > 0) {
      this.loaderService.setLoaderStatus(true);
      this.seedFulfillmentService.getDeliveryInstructions(accountNumber, productLineId).subscribe(result => {
        if (result && result.length > 0) {
          result.map((x, count) => {
            if (this.productLineDeliveryInstructionSliderModelService.releaseContactId) {
              x['selectedDI'] = x.contactId == this.productLineDeliveryInstructionSliderModelService.releaseContactId ? this.productLineDeliveryInstructionSliderModelService.releaseContactId : 0;
            }
            x['isDisabled'] = true;
            x['id'] = count + 1;
            x['isEmailValid'] = true;
            x['isPhoneValid'] = true;
            x['isContactTypeValid'] = true;
            return x;
          });
          this.deliveryInstructionDS = new MatTableDataSource(result);
        }
        else {
          this.deliveryInstructionDS = new MatTableDataSource(new Array<DeliveryInstructionsData>());
        }
        this.loaderService.setLoaderStatus(false);
        // this.enableDisableSave();
      }, (error => {
        LolLoggerService.error(error);
        this.loaderService.setLoaderStatus(false);
        // this.enableDisableSave();
      }));
    }
  }

  onAddProduct() {
    this.isRadioButtonDisabled = true;
    this.isSaveDisabled = true;
    const blankData = new DeliveryInstructionsData();
    // assigning id based on the data present in last of array
    const prevData = this.deliveryInstructionDS?.data == undefined ? [] : this.deliveryInstructionDS.data;
    blankData.id = prevData.length == 0 ? prevData.length + 1 : prevData.slice(-1)[0].id + 1;
    blankData.productLine = '';
    blankData.contactType = '';
    blankData.firstName = '';
    blankData.lastName = '';
    blankData.phoneNumber = '';
    blankData.email = '';
    blankData.accountNumber = this.productLineDeliveryInstructionSliderModelService.accountNumber;
    blankData.deliveryCodes = new Array<string>();
    blankData.isDisabled = false;
    blankData.sarEmail = "N";
    this.deliveryInstructionDS = new MatTableDataSource([...prevData, blankData]);
    this.editDeliveryInstruction(blankData.id);
  }

  editDeliveryInstruction(id: number) {
    // get index of object with id
    this.deliveryInstructionDS.data.forEach(di => {
      if (di.id == id) {
        di.isDisabled = false;
        // this.isSaveDisabled = false;
        return;
      }
    });
  }

  deleteProducts(data: any) {
    if (!data.contactId) {
      // get index of object with id
      const tempData = this.deliveryInstructionDS?.data;
      const removeIndex = tempData.map(function (item) { return item.id; }).indexOf(data.id);
      // remove object
      tempData.splice(removeIndex, 1);
      this.deliveryInstructionDS = new MatTableDataSource(tempData);
      this.isRadioButtonDisabled = false;
      this.validateDeliveryInstructionData();
    }
    else {
      const title = 'Delete';
      const message = 'Do you want to delete this saved record?';
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '480px',
        data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No', dialogType: 'confirm' }
      });
      dialogRef.afterClosed().subscribe(result => {
        // If user selected Yes
        if (result == true) {
          this.loaderService.setLoaderStatus(true);
          this.deliveryInstructionService.deleteDeliveryInstruction(data.contactId).subscribe(result => {
            // this.navigateToDeliveryinstructions();

            // get index of object with id
            const tempData = this.deliveryInstructionDS?.data;
            const removeIndex = tempData.map(function (item) { return item.id; }).indexOf(data.id);
            // remove object
            tempData.splice(removeIndex, 1);
            this.deliveryInstructionDS = new MatTableDataSource(tempData);
            this.broadcastService.broadcast(this.configService.DELIVERY_INSTRUCTION_ADD_UPDATE_CHANGE, this.deliveryInstructionDS.data);
            this.loaderService.setLoaderStatus(false);
            this.toastrService.success('Delivery Instructions deleted successfully.');
            if (data.selectedDI != 0) {
              this.selectDeliveryInstruction(new DeliveryInstructionsData());
            }
          }, error => LolLoggerService.error(error));
        }
      });
    }
  }

  onInputChange(data: DeliveryInstructionsData, fieldName: string) {
    // Find index of specific object using findIndex method.
    const tempData = this.deliveryInstructionDS?.data;
    const objIndex = tempData.findIndex((obj => obj.id == data.id));

    // Update object's name property.
    tempData[objIndex][fieldName] = data[fieldName];
    this.deliveryInstructionDS = new MatTableDataSource(tempData);
    this.validateDeliveryInstructionData();
  }

  validateDeliveryInstructionData() {
    this.isValid = true;
    if (this.deliveryInstructionDS.data && this.deliveryInstructionDS.data.length > 0) {
      const ErrorMessages = JSON.parse(
        this.localStorageService.get(MasterConstants.DELIVERY_INSTRUCTIONS_ERROR_MESSAGE)
      );
      const deliveryInstructionMaxLenError = ErrorMessages.find((msg) => msg.configName === 'DeliveryInstructionMaxLenError');

      for (let x of this.deliveryInstructionDS.data) {
        if (!x.firstName || !x.lastName || !this.isValidateEmail(x.email) ||
          !this.IsValidatePhone(x.phoneNumber) || !x.contactType ||
          !x.productLine || !x.email) {
          this.isValid = false;
          break;
        }

        let fieldLength = x.firstName.length + 1 + x.phoneNumber.length;

        for (let item of x.deliveryCodes) {
          fieldLength += 1 + item.length;
        }

        if (fieldLength > 60) {
          if (deliveryInstructionMaxLenError) {
            this.toastrService.error(deliveryInstructionMaxLenError.configValue);
          }
          this.isValid = false;
          break;
        }
      }
    } else {
      this.isValid = false;
    }

    this.isSaveDisabled = !this.isValid;
  }
  // Validate the email address entered
  validateEmail(data: DeliveryInstructionsData) {
    data.isEmailValid = true;
    if (data.email) {
      data.email = data.email.replace(/  +/g, ' ');
    }
    if (this.commonService.validateEmail(data.email, true)) {
      data.isEmailValid = false;
    }
    if (data.isEmailValid) {
      this.validateDeliveryInstructionData();
    }
    else {
      this.isSaveDisabled = true;
    }
  }

  isValidateEmail(data: any) {
    if (data) {
      data = data.replace(/  +/g, ' ');
    }
    if (this.commonService.validateEmail(data, true)) {
      return false;
    }
    return true;
  }
  // Validate the phone entered
  validatePhone(data: DeliveryInstructionsData) {
    data.isPhoneValid = true;
    if (data.phoneNumber && data.phoneNumber.length != 10) {
      data.isPhoneValid = false;
    }
    else if (!data.phoneNumber) {
      data.isPhoneValid = false;
    }
    if (data.isPhoneValid) {
      this.validateDeliveryInstructionData();
    }
    else {
      this.isSaveDisabled = true;
    }
  }

  IsValidatePhone(data: any) {
    if (data && data.length == 10) {
      return true;
    }
    return false;
  }

  setDeliveryInstruction(data: DeliveryInstructionsData) {
    this.selectedDI = data;
    this.isSelectDIDisabled = false;
  }

  selectDeliveryInstruction(data: DeliveryInstructionsData) {
    if (data == null) { data = this.selectedDI; }
    this.broadcastService.broadcast(this.configService.DELIVERY_INSTRUCTION_CHANGE, data);
    this.isSelectDIDisabled = true;
  }
  saveDeliveryInstructions() {
    this.error = false;
    const deliveryInstructionsSubmitData = this.deliveryInstructionDS.data.filter(x => x.isDisabled == false);
    this.validateDeliveryInstructionData();
    if (deliveryInstructionsSubmitData && deliveryInstructionsSubmitData.length > 0 && this.isValid) {
      deliveryInstructionsSubmitData.forEach(x => {
        const duplicateDI = this.deliveryInstructionDS.data.filter(d => d.contactType == x.contactType && d.productLine == x.productLine);
        if (duplicateDI && duplicateDI.length > 1) {
          this.toastrService.error('Same contact type can not be added in one product line');
          this.error = true;
          return;
        }
      });
    }
    if (!this.error) {
      this.loaderService.setLoaderStatus(true);
      this.deliveryInstructionService.saveDeliveryInstruction(deliveryInstructionsSubmitData).subscribe(result => {
        if (result && result.length > 0) {
          result.forEach(x => {
            this.deliveryInstructionDS.data.forEach(dis => {
              if (!dis.contactId) {
                if (dis.productLine == x.productLine && dis.contactType == x.contactType) {
                  dis.contactId = x.contactId;
                  dis.isDisabled = true;
                  return;
                }
              }
              else if (dis.isDisabled == false) {
                dis.isDisabled = true;
              }
            });
          });
        }
        const selectedDeliveryInstruction = deliveryInstructionsSubmitData.filter(x => x.selectedDI != 0);
        if (selectedDeliveryInstruction && selectedDeliveryInstruction.length > 0) {
          this.selectDeliveryInstruction(selectedDeliveryInstruction[0]);
        }
        this.isSaveDisabled = true;
        this.isRadioButtonDisabled = false;
        this.loaderService.setLoaderStatus(false);
        this.broadcastService.broadcast(this.configService.DELIVERY_INSTRUCTION_ADD_UPDATE_CHANGE, this.deliveryInstructionDS.data);
        this.toastrService.success('Delivery Instructions saved successfully.');
      }, error => LolLoggerService.error(error));
    }
  }

  // Set Dynamic Height of the Modified product listing table
  setSeedEditPageHeight() {
    const seedEditHeight = window.innerHeight - $('.navbar').outerHeight() - $('.SeedFulfillBtnSec').outerHeight();
    $('.seedEfulfillmentOuter').css('height', seedEditHeight + 'px');
  }
  onCheckboxChange(id: number, isChecked: boolean): void {
    this.isSaveDisabled = false;
    const record = this.deliveryInstructionDS.data.find((item: { id: number; sarEmail: string }) => item.id === id);
    if (record) {
      record.sarEmail = isChecked ? 'Y' : 'N';
    }
  }

}

export class DeliveryInstructionsData {
  id: number;
  contactId: number;
  accountNumber: number;
  productLine: string;
  contactType: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  active: string;
  isDefault = false;
  deliveryCodes: Array<string> = [];
  isDisabled = true;
  isDelete: boolean;
  selectedDI = 0;
  isEmailValid = true;
  isPhoneValid = true;
  isContactTypeValid = true;
  sarEmail: string;
}
export var ContactType = [{ id: 'P', value: 'Primary' }, { id: 'A1', value: 'Alternate 1' },
{ id: 'A2', value: 'Alternate 2' }, { id: 'A3', value: 'Alternate 3' },
{ id: 'A4', value: 'Alternate 4' }, { id: 'A5', value: 'Alternate 5' },
{ id: 'A6', value: 'Alternate 6' }, { id: 'A7', value: 'Alternate 7' },
{ id: 'A8', value: 'Alternate 8' }, { id: 'A9', value: 'Alternate 9' }];
export var DeliveryCodeList = [{ deliveryInstructionsCodeId: 'PJK', DeliveryCodes: 'Pallet Jack Required' }, { deliveryInstructionsCodeId: 'DAR', DeliveryCodes: 'Driver Assistance Required' }, { deliveryInstructionsCodeId: 'UMMAN', DeliveryCodes: 'Unmanned Loacation' }];
